import React, { useEffect, useState } from 'react';

import { applyDarkModeFromStorage, removeDarkMode } from '../../utils/darkMode';
import { MobileNotSupportedEmptyState } from '../EmptyStates';

interface LayoutProps {
  children: React.ReactNode;
}

export const LayoutMain: React.FC<LayoutProps> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    applyDarkModeFromStorage();

    return () => {
      removeDarkMode();
    };
  }, []);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768); // md breakpoint is 768px
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);

    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  if (isMobile) {
    return (
      <main className="relative flex flex-col justify-center items-center bg-gray-100 dark:bg-gray-900 min-h-screen">
        <MobileNotSupportedEmptyState />
      </main>
    );
  }

  return (
    <main className="relative flex flex-col bg-gray-100 dark:bg-gray-900 min-h-screen max-h-screen">{children}</main>
  );
};
